// extracted by mini-css-extract-plugin
module.exports = {"container":"StrmrmRequestedItems_container__2jAvk","table":"StrmrmRequestedItems_table__2YgT-"};